module.exports = __webpack_public_path__ + "img/effects-15.fb0a4a3d.png";